import {
  ListItemButton,
  ListItemText,
  Drawer,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Menu, useSidebarState } from 'react-admin';
import { DRAWER_WIDTH, USER_ROLE } from '../constant';
import { useCognitoUser } from '../hooks';

const MenuItem = styled(ListItemButton)(({theme}) => ({
  padding: '14px 16px',
}));

const CustomMenu = () => {
  const [open] = useSidebarState();  
  const currentUser = useCognitoUser();

  return (
    <Drawer
      variant="permanent"
      open={open}
      sx={{
        width: open ? DRAWER_WIDTH : 0,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: open ? DRAWER_WIDTH : 0,
          boxSizing: 'border-box',
          transition: 'width 0.3s',
        },
      }}
    >
      <Menu>
        {currentUser.group !== USER_ROLE.Customer && (
          <MenuItem component="a" href="#/overview">
            {open && <ListItemText primary="Virtual Patrol"/>}
          </MenuItem>
        )}
        <MenuItem component="a" href="#/logs">
          {open && <ListItemText primary="Logs"/>}
        </MenuItem>
        <MenuItem component="a" href="#/reports">
          {open && <ListItemText primary="Report"/>}
        </MenuItem>
        {![USER_ROLE.Operator, USER_ROLE.Customer].includes(currentUser.group) && (
          <MenuItem component="a" href="#/cognitoUsers">
            {open && <ListItemText primary="Users"/>}
          </MenuItem>
        )}
        {currentUser.group === USER_ROLE.AppAdmin && (
          <MenuItem component="a" href="#/checkpoints">
            {open && <ListItemText primary="Checkpoint"/>}
          </MenuItem>
        )}
        {![USER_ROLE.Operator, USER_ROLE.Customer].includes(currentUser.group) && (
          <MenuItem component="a" href="#/routes">
            {open && <ListItemText primary="Route"/>}
          </MenuItem>
        )}
        {currentUser.group !== USER_ROLE.Customer && (
          <MenuItem component="a" href="#/schedules">
            {open && <ListItemText primary="Schedule"/>}
          </MenuItem>
        )}
      </Menu>
    </Drawer>
  );
};

export default CustomMenu;

